// extracted by css-extract-rspack-plugin
export default {"fontXs":"fontXs-rlW4MX"};